import { Link, createFileRoute, useNavigate } from '@tanstack/react-router';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';
import type { ClienteDetalhe } from '@sgc/contracts';
import { post } from '../lib/api';
import { useToast } from '../ui/toast';
import { Check } from '../ui/campos';
import { FichaCliente, bodyDe, errosDe, formVazio, type FormCliente } from '../telas/clientes/ficha';

export const Route = createFileRoute('/_app/clientes/novo')({ component: NovoCliente });

function NovoCliente() {
  const nav = useNavigate();
  const toast = useToast();
  const [f, setF] = useState<FormCliente>(formVazio);
  const [onboarding, setOnboarding] = useState(true);
  const [tentou, setTentou] = useState(false);
  const erros = tentou ? errosDe(f, true) : {};

  const salvar = useMutation({
    mutationFn: () => post<ClienteDetalhe>('/v1/clientes', { ...bodyDe(f, true), onboarding }),
    // a empresa nova já chega na aba Obrigações com a Enquete aberta: é ela que diz o que o escritório vai entregar
    onSuccess: (c) => { toast.ok('cliente cadastrado — agora responda a Enquete de obrigações'); void nav({ to: '/clientes/$id', params: { id: c.id }, search: { aba: 'obrigacoes', enquete: true } }); },
    onError: (e) => toast.erro(e),
  });

  function enviar() {
    setTentou(true);
    if (Object.keys(errosDe(f, true)).length) { toast.erro('corrija os campos destacados'); return; }
    salvar.mutate();
  }

  return (
    <>
      <div className="topbar">
        <div><h1>Novo cliente</h1><div className="sub"><Link to="/clientes">clientes</Link> › novo</div></div>
        <div className="acoes">
          <Link className="btn" to="/clientes">Cancelar</Link>
          <Check rotulo="Preparar o cliente novo" valor={onboarding} onChange={setOnboarding} ajuda="cria as pastas do Drive e pede contrato social, cartão CNPJ e certificado pelo portal; a Enquete abre em seguida" />
          <button className="btn primario" type="button" disabled={salvar.isPending} onClick={enviar}>Salvar</button>
        </div>
      </div>
      <div className="conteudo">
        <FichaCliente f={f} set={(p) => setF((x) => ({ ...x, ...p }))} criando erros={erros} />
      </div>
    </>
  );
}
